import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const verifyToken = async () => {
    const token = Cookies.get('jwt_token');
    if (token) {
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/auth/verify-token`, {}, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        if (response.status === 200) {
          setIsAuthenticated(true);
        }
      } catch (error) {
        console.error('Token verification failed:', error);
        Cookies.remove('jwt_token');
        setIsAuthenticated(false);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    verifyToken();
  }, []);

  const login = (email, token, TTL, level) => {
    Cookies.set('email', email, { secure: true, sameSite: 'strict' });
    Cookies.set('jwt_token', token, { secure: true, sameSite: 'strict' });
    Cookies.set('tokenTTL', TTL, { secure: true, sameSite: 'strict' });
    Cookies.set('level', level, { secure: true, sameSite: 'strict' });
    setIsAuthenticated(true);
  };

  const logout = () => {
    Cookies.remove('email');
    Cookies.remove('jwt_token');
    Cookies.remove('tokenTTL');
    Cookies.remove('level');
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout, verifyToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 